<button
    type="button"
    class="btn sp-navbar-btn mr-5 hidden-xs btn-partner-catalog sp-navbar-btn"
    [class.shine-effect]="isShineEffectEnabled"
    [popover]="popTemplate"
    [containerClass]="'sp-popover-hint-content'"
    [outsideClick]="true"
    #popover="bs-popover"
    (click)="click()"
>
    <span class="sp-icon icon-find-partner mr-0"> </span>
</button>

<ng-template #popTemplate>
    <button type="button" class="close" (click)="popover.hide()">×</button>

    <div class="constructor-help-img">
        <img src="./assets/img/partners-catalog/pic-find-partner.svg" alt="partners-catalog-image" />
    </div>

    <p>{{ "partners_catalog_text" | translate }}</p>

    <button class="btn btn-primary btn-block" (click)="open()">{{ "partners_catalog_action" | translate }}</button>

    <ul class="constructor-help-list">
        <li>
            <a target="_blank" [href]="'partners_catalog_kb_link' | translate">
                {{ "partners_catalog_kb_text" | translate }} <i class="sp-icon icon-outgoing small-xs color-light"> </i>
            </a>
        </li>
        <li>
            <a target="_blank" [href]="'partners_catalog_kb_link_2' | translate">
                {{ "partners_catalog_kb_text_2" | translate }}
                <i class="sp-icon icon-outgoing small-xs color-light"> </i>
            </a>
        </li>
        <li>
            <a target="_blank" [href]="'partners_catalog_kb_link_3' | translate">
                {{ "partners_catalog_kb_text_3" | translate }}
                <i class="sp-icon icon-outgoing small-xs color-light"> </i>
            </a>
        </li>
    </ul>
</ng-template>
